<template>
  <MainSoftForm>
    <!--Start form body    ------------------------------------------------------------------>
    <template v-slot:body>
      <!--Start form wrapper for catch errors  ------------------------>
      <FormGenerator
        lg="6"
        :schema="schema"
        :validator="$v"
        :enter="submit"
      ></FormGenerator>
      <!--End   form wrapper for catch errors  ------------------------>
    </template>
    <!--End   form body    ------------------------------------------------------------------>

    <!--Start form actions ------------------------------------------------------------------>
    <template v-slot:action>
      <v-col cols="12" class="d-flex justify-space-between pa-0">
        <v-col cols="12" md="6">
          <v-btn
            color="primary"
            block
            @click="submit"
            :loading="is_loading"
            :disabled="is_loading || $v.$error"
          >
            {{ cert ? $_t("attribute.edit") : $_t("attribute.send") }}
          </v-btn>
        </v-col>
        <v-col cols="12" md="6">
          <v-btn
            block
            :disabled="is_loading"
            color="primary"
            width="200px"
            @click="cancel"
          >
            {{ $_t("attribute.cancel") }}
          </v-btn>
        </v-col>
      </v-col>
    </template>
    <!--End   form actions ------------------------------------------------------------------>
  </MainSoftForm>
</template>

<script>
import MainSoftForm from "@/components/app/form/MainSoftForm";
import FormGenerator from "@/components/app/form/MyFormGenerator";
import { mapGetters } from "vuex";
import { CERT_FORM_SCHEMA } from "@/packages/dashboard/schema/CERT_FORM_SCHEMA";
import jalali_moment from "moment-jalaali";
import { required } from "vuelidate/lib/validators";
import message from "@/tools/Message";
export default {
  components: { MainSoftForm, FormGenerator },
  name: "CertForm",
  computed: {
    ...mapGetters({
      is_loading: "loading/is_loading",
      cert: "dashboard/get_cert",
      certs: "dashboard/get_certs",
    }),
  },
  data: () => ({
    schema: CERT_FORM_SCHEMA.schema,
    form: CERT_FORM_SCHEMA.model,
    validation_rules: {},
  }),
  validations() {
    return {
      form: this.validation_rules,
    };
  },
  created() {
    if (!this.$route.params.id && this.$route.name !== "dashboard.cert.edit")
      this.validation_rules = {
        fullName: {
          required,
        },
        nationalCode: {
          required,
        },
        level: {
          required,
        },
        levelType: {
          required,
        },
        birthday: {
          required,
        },
        lastMajor: {
          required,
        },
        address: {
          required,
        },
        postalCode: {
          required,
        },
        personalPhoto: {
          required,
        },
        nationalCartPhoto: {
          required,
        },
        howToSend: {
          required,
        },
        startTime: {
          required,
        },
      };
    else
      this.validation_rules = {
        fullName: {
          required,
        },
        nationalCode: {
          required,
        },
        level: {
          required,
        },
        levelType: {
          required,
        },
        birthday: {
          required,
        },
        lastMajor: {
          required,
        },
        address: {
          required,
        },
        postalCode: {
          required,
        },
        personalPhoto: {},
        nationalCartPhoto: {},
        howToSend: {
          required,
        },
        startTime: {
          required,
        },
      };
  },
  methods: {
    async submit() {
      try {
        if (!this.isFormValidate()) return;
        let data = {
          fullName: this.form.fullName,
          nationalCode: this.form.nationalCode,
          level: this.form.level,
          levelType: this.form.levelType,
          birthday: this.form.birthday,
          lastMajor: this.form.lastMajor,
          address: this.form.address,
          postalCode: this.form.postalCode,
          howToSend: this.form.howToSend,
          startTime: this.form.startTime,
        };
        let personalPhotoId = null;
        let nationalPhotoId = null;
        if (this.form.personalPhoto) {
          const personalPhoto = new FormData();
          personalPhoto.append("file", this.form.personalPhoto);
          personalPhotoId = await this.$actions.uploadImage(personalPhoto);
          data.personalPhoto = personalPhotoId.data;
        }
        if (this.form.nationalCartPhoto) {
          const nationalPhoto = new FormData();
          nationalPhoto.append("file", this.form.nationalCartPhoto);
          nationalPhotoId = await this.$actions.uploadImage(
            nationalPhoto,
            "national"
          );
          data.nationalCartPhoto = nationalPhotoId.data;
        }

        if (!this.cert) await this.$actions.createCert(data);
        else await this.$actions.editCert(data, this.cert.certificateId);
        this.cancel();
      } catch (e) {
        this.cancel();
        console.log(e);
      }
    },
    cancel() {
      this.$router.push({ name: "dashboard.main" });
      this.$store.dispatch("dashboard/setCert", null);
    },
    clearForm() {
      this.form.address = null;
      this.form.level = null;
      this.form.birthday = null;
      this.form.fullName = null;
      this.form.howToSend = null;
      this.form.lastMajor = null;
      this.form.levelType = null;
      this.form.nationalCode = null;
      this.form.postalCode = null;
      this.form.nationalCartPhoto = null;
      this.form.personalPhoto = null;
      this.form.startTime = jalali_moment(new Date())
        .locale("fa")
        .format("jYYYY/jMM/jDD");
    },
    bindForm(cert) {
      this.form.address = cert.address;
      this.form.level = cert.level;
      this.form.birthday = cert.birthday;
      this.form.fullName = cert.fullName;
      this.form.howToSend = cert.howToSend;
      this.form.lastMajor = cert.lastMajor;
      this.form.levelType = cert.levelType;
      this.form.nationalCode = cert.nationalCode;
      this.form.postalCode = cert.postalCode;
      this.form.startTime = cert.startTime;
      this.form.nationalCartPhoto = null;
      this.form.personalPhoto = null;
    },
  },
  async mounted() {
    if (this.$route.params.id && this.$route.name === "dashboard.cert.edit") {
      await this.$actions.getCerts({});
      if (this.cert) {
        this.bindForm({ ...this.cert });
        return;
      }
      let cert = this.certs.find(
        (cert) => cert.certificateId === this.$route.params.id
      );
      if (cert) {
        this.bindForm({ ...cert });
        await this.$store.dispatch("dashboard/setCert", cert);
      } else cert = await this.$actions.getSingleCert(this.$route.params.id);

      if (cert) this.bindForm({ ...cert });
      else {
        message.error("مدرک یافت نشد");
        await this.$router.push({ name: "dashboard.main" });
      }
    }
  },
  destroyed() {
    this.$store.dispatch("dashboard/setCert", null);
    this.clearForm();
  },
};
</script>

<style scoped></style>
